import { useContext } from "react";
import styled, { keyframes } from "styled-components";
import { LocalContext } from "../../LocalProvider";
import { colors } from "../../styles/variables";

const loaderAnimation = keyframes`
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
`
const LoadingWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.transparent};
  color: ${colors.black};
  z-index: 100;
  flex-direction: column-reverse;

  &:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: ${colors.color2} transparent ${colors.color2} transparent;
    animation: ${loaderAnimation} 1.2s linear infinite;
  }
`;

const Loading = props => {
  const { translate } = useContext(LocalContext);
  return <LoadingWrapper>
    {/*{translate("Loading")}*/}
    {/*  ...*/}
    </LoadingWrapper>;
};

Loading.propTypes = {};

export default Loading;
